import { Badge } from '@/components/ui/badge';
import GenericSearchBar from '../search/GenericSearchBar';
import { getProjectSuggestions } from '../../services/apiService';
import type { ProjectSuggestion } from '../../types/api';
import type { ResultFilters } from './ResultsFilterRow';

type Op = 'AND' | 'OR';

interface ResultSearchBarProps {
  filters?: ResultFilters;
  onSearch?: (keywords: string[], ops: Op[]) => void;
  initialValue?: string;
}

export default function ResultSearchBar({ filters, onSearch, initialValue }: ResultSearchBarProps = {}) {
  return (
    <GenericSearchBar<ProjectSuggestion>
      namespace="projects"
      destinationPath="/outcomes"
      detailPath={(s) => `/outcome/${encodeURIComponent(s.id)}`}
      suggestionsHeadingKey="command.resultsHeading"
      fetchSuggestions={getProjectSuggestions}
      renderSuggestionItem={(s, { highlight }) => (
        <>
          <span className="flex-1 truncate">{highlight(s.name)}</span>
          {s.year != null && (
            <Badge variant="outline" className="ml-1 h-5 px-1.5 text-[10px] font-normal text-ctu-text-muted">
              {s.year}
            </Badge>
          )}
          {s.type && (
            <Badge variant="outline" className="h-5 px-1.5 text-[10px] font-normal text-ctu-text-muted">
              {s.type}
            </Badge>
          )}
        </>
      )}
      filters={filters}
      onSearch={onSearch}
      initialValue={initialValue}
    />
  );
}
